import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './index.css';
import { subscribeToNewsletter } from '../../services/apiService';
import SuggestionsList from '../FindFlightsBlock/SearchForm/components/AirpotInput/SuggestionsList';
import { getThemeName } from '../../helpers/urlParams';

const SubscribeForm = ({ isInnerPage, smallSize = false }) => {
  const dataTheme = getThemeName();
  const [phoneValue, changePhoneValue] = React.useState('');
  const [inputValue, changeValue] = React.useState('');
  const [emailAgreement, setEmailAgreement] = React.useState(false);
  const [smsAgreement, setSmsAgreement] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');

  const [displaySuccessMessage, changeDisplaySuccessMessage] = React.useState(
    false
  );
  const [displayError, changeDisplayError] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);

  useEffect(() => {
    if (
      displayError ||
      (inputValue === '' && phoneValue === '') ||
      (inputValue !== '' && !emailAgreement) ||
      (phoneValue !== '' && !smsAgreement)
    ) {
      console.log(inputValue + emailAgreement + phoneValue + smsAgreement);
      setDisabled(true);
    } else {
      console.log('all good');
      setDisabled(false);
    }
  }, [emailAgreement, smsAgreement, inputValue, phoneValue, displayError]);

  const handleInputChange = e => {
    const trimmedInput = e.target.value.replace(/\s/g, '');
    if (/^[^@]+@[^@]+\.[^@]+$/.test(trimmedInput)) {
      changeDisplayError(false);
      changeValue(e.target.value);
      return;
    }
    changeDisplayError(true);
    setErrorMessage('Please provide a correct email address');
    changeValue(e.target.value);
  };

  const handlePhoneChange = e => {
    const targetValue = e.target.value;
    let formattedValue = targetValue.trim();

    if (formattedValue.length >= 12 && !/[^0-9+]/.test(targetValue)) {
      changeDisplayError(false);
      changePhoneValue(e.target.value);
      return;
    }

    changeDisplayError(true);
    setErrorMessage('Please provide a correct phone number with country code');
    changePhoneValue(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    changeDisplaySuccessMessage(!displaySuccessMessage);
    subscribeToNewsletter({
      email: inputValue,
      contactNumber: phoneValue,
      source: 'subscribeToNewsletter'
    });
  };
  return (
    <React.Fragment>
      <div
        className={`${smallSize ? 'small-size' : 'block-wrapper'} d-flex ${
          isInnerPage ? 'inner-page-block-wrapper' : ''
        }`}
      >
        <div className="subscribe-wrapper d-flex" data-theme={dataTheme}>
          <form className="subscribe-form d-flex" data-subscription-form>
            <div className="img-wrapper">
              <div className="subscribe-icon"></div>
            </div>
            <div className="submit-block">
              <h3>Subscribe to our newsletter and save!</h3>
              <p>
                Receive hot deals, secret promos and new articles on Email/ SMS/
                WhatsApp
              </p>
              {!displaySuccessMessage && (
                <>
                  <div className="email-and-phone-fields">
                    <div className="input-and-consent">
                      <input
                        className="field-input"
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        placeholder="your.email@mail.com"
                      />
                      <div className="checkbox-wrapper">
                        <input
                          className="checkbox-email-consent"
                          type="checkbox"
                          name="email-consent"
                          onChange={e => setEmailAgreement(e.target.checked)}
                        />
                        <label>I agree to receive Email from Travelopod</label>
                      </div>
                    </div>
                    <p className="margin-top-20"></p>
                    <div className="input-and-consent">
                      <input
                        className="field-input"
                        type="tel"
                        value={phoneValue}
                        placeholder="+X XXX XXX XXXX"
                        onChange={handlePhoneChange}
                      />
                      <div className="checkbox-wrapper">
                        <input
                          className="checkbox-phone-consent"
                          type="checkbox"
                          name="phone-consent"
                          onChange={e => setSmsAgreement(e.target.checked)}
                        />
                        <label>I agree to receive SMS from Travelopod</label>
                      </div>
                    </div>
                  </div>
                  <div className="submit-btn-wrapper">
                    {/* <div className="checkbox-wrapper">
                      <input
                        type="checkbox"
                        id="consent-checkbox"
                        name="consent-checkbox"
                        onChange={e => setEmailAgreement(e.target.checked)}
                      />
                      <label for="consent-checkbox">
                        I agree to receive Email/ SMS from Travelopod
                      </label>
                    </div> */}
                    <div className="btn-submit">
                      <button
                        disabled={disabled}
                        type="submit"
                        onClick={handleSubmit}
                      >
                        Subscribe
                      </button>
                    </div>
                  </div>
                </>
              )}
              {displayError && (
                <span className="input-error">
                  <span className="input-error">{errorMessage}</span>
                </span>
              )}

              {displaySuccessMessage && (
                <div className="submit-block success d-flex">
                  <span>Success</span>
                  <div className="success-icon" />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SubscribeForm;

SubscribeForm.propTypes = {
  isInnerPage: PropTypes.bool
};

SuggestionsList.defaultProps = {
  isInnerPage: false
};
